import { cloneDeep } from "lodash";

export const setActiveContentRequired = ({
  contents,
  activeContentId,
  required,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.required = required;
    }

    return cloneDeep(content);
  });
};

export default setActiveContentRequired;
